import React, { useEffect, useState } from 'react';
import {
  Grow,
  makeStyles, Typography, useTheme,
} from '@material-ui/core';
import { defaultModalProps } from 'modal-tpyes';

export type snackbarColor = 'primary'|'secondary'

export interface SnackbarModalProps {
	actionType:snackbarColor
  snackbarMessage:string
}

const useStyles = makeStyles((theme) => ({
  root:{
    position:"fixed",
    zIndex: theme.zIndex.drawer + 200,
    backgroundColor:theme.palette.primary.main,
    // height:40,
    // width:156,
    left:24,
    borderRadius:theme.spacing(1),
    display:'flex',
    alignItems:"center",
    justifyContent:"center",
    padding:theme.spacing(3),
    height:40,
    bottom: 24,
    [theme.breakpoints.up('md')] : {
      bottom:64,
      // width:"100%"
    },
    [theme.breakpoints.down('xs')] : {
      right:24
    },
  }
}));

let timer:NodeJS.Timeout

const SnackbarModal: React.FC<defaultModalProps> = ({
  open,
  handleBack,
  handleClose,
  props: modalProps,
}) => {

  const classes = useStyles();
  const theme = useTheme()
  // const [openSnackbar,setOpenSnakbar] = useState(false)
  const [snakbarColor,setSnackbarColor] = useState(theme.palette.primary.main)
  const [snackbarMessage,setSnackbarMessage] = useState("")

  useEffect(() => {
		if (modalProps && open) {
			let props:SnackbarModalProps = modalProps
      if (props.actionType === "primary") setSnackbarColor(theme.palette.primary.main)
      if (props.actionType === "secondary") setSnackbarColor(theme.palette.secondary.main)
      if (props.snackbarMessage) setSnackbarMessage(props.snackbarMessage)
      clearTimeout(timer)
      timer = setTimeout(()=>{
        handleClose()
      },3000)
		}
	}, [modalProps]);

  return (
    <Grow in={open}>
      <div 
        className={classes.root} 
        style={{backgroundColor:snakbarColor}}
      >
        <Typography>{snackbarMessage}</Typography>
      </div>
    </Grow>
  )
}

export default SnackbarModal;
